import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';

interface TipoOpcao {
  id: number;
  nome: string;
}

interface CronogramaBase {
  id: number;
  nome: string;
  dataCriacao: Date;
}

interface Empresa {
  id: number;
  nome: string;
}

interface CronogramaItemBase {
  idCronogramaItemBase: number;
  idCronogramaBase: number;
  nome: string;
  descricao: string | null;
  ordem: number;
  prazoEmDias: number;
}

interface CronogramaItemOpcaoBase {
  idCronogramaItemOpcaoBase: number;
  idCronogramaItemBase: number;
  idCronogramaItemOpcaoBasePai: number | null;
  idTipoOpcao: number;
  nome: string;
  ordem: number;
  descricao?: string;
  idTriagem?: number | null;
}

interface Triagem {
  id: number;
  titulo: string;
}

@Component({
  selector: 'app-cronograma-teste',
  templateUrl: './cronograma-teste.component.html',
  styleUrls: ['./cronograma-teste.component.scss']
})
export class CronogramaTesteComponent implements OnInit {
  @ViewChild('modalNovoCronograma') modalNovoCronograma: any;
  @ViewChild('modalNovoItem') modalNovoItem: any;
  @ViewChild('modalNovaOpcao') modalNovaOpcao: any;

  cronogramaForm: FormGroup;
  itemForm: FormGroup;
  isEditing = false;
  cronogramas: CronogramaBase[] = [];
  itens: CronogramaItemBase[] = [];
  opcoes: CronogramaItemOpcaoBase[] = [];
  dtOptions: DataTables.Settings = {};
  
  // Propriedades para controle de seleção
  cronogramaSelecionado: CronogramaBase | null = null;
  itemSelecionado: CronogramaItemBase | null = null;
  opcaoSelecionada: CronogramaItemOpcaoBase | null = null;
  
  // Formulário para edição de opção
  opcaoForm: FormGroup;

  // Propriedades para o modal de novo cronograma
  empresas: Empresa[] = [];
  tiposOpcao: TipoOpcao[] = [];

  triagens: Triagem[] = [];
  showFormSelect = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    public modalService: NgbModal,
    private ajax: AjaxService,
    private util: UtilService
  ) {
    this.createForms();
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.carregarCronogramas();
    this.carregarEmpresas();
    this.carregarTiposOpcao();
  }

  createForms() {
    this.cronogramaForm = this.fb.group({
      nome: ['', [Validators.required]],
      dataCriacao: [new Date(), [Validators.required]]
    });

    this.itemForm = this.fb.group({
      nome: ['', [Validators.required]],
      descricao: [''],
      ordem: [1, [Validators.required, Validators.min(0)]],
      prazoEmDias: [0, [Validators.required, Validators.min(0)]]
    });

    this.opcaoForm = this.fb.group({
      nome: ['', [Validators.required]],
      ordem: [0, [Validators.required, Validators.min(0)]],
      idTipoOpcao: [1, [Validators.required]],
      descricao: [''],
      idTriagem: [null]
    });

    this.opcaoForm.get('idTipoOpcao').valueChanges.subscribe(value => {
      this.onTipoOpcaoChange(value);
    });
  }

  onTipoOpcaoChange(value: string) {
    if (value === '1') {
      this.carregarTriagens();
    } else {
      this.opcaoForm.patchValue({
        idTriagem: null
      });
    }
  }

  abrirModalNovoCronograma() {
    this.cronogramaSelecionado = null;
    this.itemSelecionado = null;
    this.opcaoSelecionada = null;
    this.cronogramaForm.reset({
      dataCriacao: new Date()
    });
    this.modalService.open(this.modalNovoCronograma, {
      backdrop: 'static',
      keyboard: false
    });
  }

  carregarEmpresas() {
    // Aqui você deve implementar a chamada à sua API
    this.empresas = [
      { id: 1, nome: 'Empresa 1' },
      { id: 2, nome: 'Empresa 2' }
    ];
  }

  onSubmit() {
    if (this.cronogramaForm.valid) {
      this.util.showLoading();
      const novoCronograma: CronogramaBase = {
        ID_CRONOGRAMA_BASE: this.cronogramaSelecionado?.id || 0,
        ...this.cronogramaForm.value
      };

      const url = this.cronogramaSelecionado
        ? `${API}CronogramaBase/CronogramaBase?ID_CRONOGRAMA_BASE=${this.cronogramaSelecionado.id}`
        : `${API}CronogramaBase/CronogramaBase`;

      const request = this.cronogramaSelecionado
        ? this.ajax.put(url, novoCronograma)
        : this.ajax.post(url, novoCronograma);

      request.subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.util.toasterShowSuccess("Sucesso", 
              this.cronogramaSelecionado ? "Cronograma atualizado com sucesso!" : "Cronograma cadastrado com sucesso!");
            this.modalService.dismissAll();
            this.carregarCronogramas();
          } else {
            this.util.toasterShowError("Erro", "Erro ao salvar cronograma. Tente novamente.");
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", error.error.message || "Erro ao salvar cronograma. Tente novamente.");
          console.error('Erro ao salvar cronograma:', error);
        }
      });
    } else {
      this.util.toasterShowError("Atenção", "Por favor, preencha todos os campos obrigatórios.");
    }
  }

  carregarCronogramas() {
    this.util.showLoading();
    this.ajax.get(`${API}CronogramaBase/CronogramaBase`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.cronogramas = response.data.map((cronograma: any) => ({
              id: cronograma.id,
              nome: cronograma.nome,
              dataCriacao: new Date(cronograma.datA_CRIACAO)
            }));
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar cronogramas. Tente novamente.");
          console.error('Erro ao carregar cronogramas:', error);
        }
      });
  }

  carregarItens(cronogramaId: number) {
    this.util.showLoading();
    debugger
    this.ajax.get(`${API}CronogramaItemBase/CronogramaItemBase?ID_CRONOGRAMA_BASE=${cronogramaId}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.itens = response.data.map((item: any) => ({
              idCronogramaItemBase: item.iD_CRONOGRAMA_ITEM_BASE,
              idCronogramaBase: item.iD_CRONOGRAMA_BASE,
              nome: item.nome,
              descricao: item.descricao,
              ordem: item.ordem,
              prazoEmDias: item.prazO_EM_DIAS
            }));
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar itens. Tente novamente.");
          console.error('Erro ao carregar itens:', error);
        }
      });
  }

  carregarOpcoes(itemId: number) {
    this.util.showLoading();
    this.ajax.get(`${API}CronogramaItemOpcaoBase/CronogramaItemOpcaoBase?ID_CRONOGRAMA_ITEM_BASE=${itemId}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {

            debugger
            this.opcoes = response.data.map((opcao: any) => ({
              idCronogramaItemOpcaoBase: opcao.iD_CRONOGRAMA_ITEM_OPCAO_BASE,
              idCronogramaItemBase: opcao.iD_CRONOGRAMA_ITEM_BASE,
              idCronogramaItemOpcaoBasePai: opcao.iD_CRONOGRAMA_ITEM_OPCAO_BASE_PAI,
              idTipoOpcao: opcao.iD_TIPO_OPCAO,
              nome: opcao.nome,
              ordem: opcao.ordem,
              descricao: opcao.descricao,
              idTriagem: opcao.iD_TRIAGEM
            }));
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar opções. Tente novamente.");
          console.error('Erro ao carregar opções:', error);
        }
      });
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      this.cronogramaForm.enable();
    } else {
      this.cronogramaForm.disable();
    }
  }

  expandirCronograma(cronograma: CronogramaBase) {
    this.cronogramaSelecionado = cronograma;
    this.itemSelecionado = null;
    this.opcaoSelecionada = null;
    this.carregarItens(cronograma.id);
  }

  expandirItem(item: CronogramaItemBase) {
    this.itemSelecionado = item;
    this.opcaoSelecionada = null;
    this.carregarOpcoes(item.idCronogramaItemBase);
  }

  selecionarOpcao(opcao: CronogramaItemOpcaoBase) {
    this.opcaoSelecionada = opcao;
    this.opcaoForm.patchValue({
      nome: opcao.nome,
      ordem: opcao.ordem,
      idTipoOpcao: opcao.idTipoOpcao.toString(),
      descricao: opcao.descricao,
      idTriagem: opcao.idTriagem
    });

    if (opcao.idTipoOpcao === 1) {
      this.carregarTriagens();
    }
  }

  novoItem() {
    this.itemSelecionado = null;
    this.opcaoSelecionada = null;
    if (this.cronogramaSelecionado) {
      this.itemForm.reset({
        ordem: this.itens.length + 1,
        prazoEmDias: 0
      });
      this.modalService.open(this.modalNovoItem, {
        backdrop: 'static',
        keyboard: false
      });
    }
  }

  editarItem(item: CronogramaItemBase) {
    this.itemSelecionado = item;
    this.itemForm.patchValue({
      nome: item.nome,
      descricao: item.descricao,
      ordem: item.ordem,
      prazoEmDias: item.prazoEmDias
    });
    this.modalService.open(this.modalNovoItem, {
      backdrop: 'static',
      keyboard: false
    });
  }

  salvarItem() {
    if (this.itemForm.valid && this.cronogramaSelecionado) {
      this.util.showLoading();
      const novoItem: CronogramaItemBase = {
        ID_CRONOGRAMA_ITEM_BASE: this.itemSelecionado?.idCronogramaItemBase || 0,
        ID_CRONOGRAMA_BASE: this.cronogramaSelecionado.id,
        PRAZO_EM_DIAS: this.itemForm.value.prazoEmDias,
        ...this.itemForm.value
      };

      const url = this.itemSelecionado
        ? `${API}CronogramaItemBase/CronogramaItemBase?ID_CRONOGRAMA_ITEM_BASE=${this.itemSelecionado.idCronogramaItemBase}`
        : `${API}CronogramaItemBase/CronogramaItemBase`;

      const request = this.itemSelecionado
        ? this.ajax.put(url, novoItem)
        : this.ajax.post(url, novoItem);

      request.subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.util.toasterShowSuccess("Sucesso", 
              this.itemSelecionado ? "Item atualizado com sucesso!" : "Item cadastrado com sucesso!");
            this.modalService.dismissAll();
            this.carregarItens(this.cronogramaSelecionado.id);
          } else {
            this.util.toasterShowError("Erro", "Erro ao salvar item. Tente novamente.");
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", error.error.message || "Erro ao salvar item. Tente novamente.");
          console.error('Erro ao salvar item:', error);
        }
      });
    } else {
      this.util.toasterShowError("Atenção", "Por favor, preencha todos os campos obrigatórios.");
    }
  }

  novaOpcao() {
    if (this.itemSelecionado) {
      this.modalService.open(this.modalNovaOpcao, { size: 'lg' });
    }
  }

  salvarOpcao() {
    if (this.opcaoForm.valid && this.itemSelecionado) {
      this.util.showLoading();
      debugger
      const novaOpcao: CronogramaItemOpcaoBase = {
        ID_CRONOGRAMA_ITEM_OPCAO_BASE: this.opcaoSelecionada?.idCronogramaItemOpcaoBase || 0,
        ID_CRONOGRAMA_ITEM_BASE: this.itemSelecionado.idCronogramaItemBase,
        ID_TIPO_OPCAO: parseInt(this.opcaoForm.value.idTipoOpcao),
        ID_CRONOGRAMA_ITEM_OPCAO_BASE_PAI: this.opcaoSelecionada?.idCronogramaItemOpcaoBasePai || null,
        ID_TRIAGEM: this.opcaoForm.value.idTipoOpcao == 1 ? parseInt(this.opcaoForm.value.idTriagem) : null,
        ...this.opcaoForm.value
      };

      const url = this.opcaoSelecionada
        ? `${API}CronogramaItemOpcaoBase/CronogramaItemOpcaoBase?ID_CRONOGRAMA_ITEM_OPCAO_BASE=${this.opcaoSelecionada.idCronogramaItemOpcaoBase}`
        : `${API}CronogramaItemOpcaoBase/CronogramaItemOpcaoBase`;

      const request = this.opcaoSelecionada
        ? this.ajax.put(url, novaOpcao)
        : this.ajax.post(url, novaOpcao);

      request.subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.util.toasterShowSuccess("Sucesso", 
              this.opcaoSelecionada ? "Opção atualizada com sucesso!" : "Opção cadastrada com sucesso!");
            this.modalService.dismissAll();
            this.carregarOpcoes(this.itemSelecionado.idCronogramaItemBase);
          } else {
            this.util.toasterShowError("Erro", "Erro ao salvar opção. Tente novamente.");
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", error.error.message || "Erro ao salvar opção. Tente novamente.");
          console.error('Erro ao salvar opção:', error);
        }
      });
    } else {
      this.util.toasterShowError("Atenção", "Por favor, preencha todos os campos obrigatórios.");
    }
  }

  abrirModalNovaOpcao() {
    this.opcaoSelecionada = null;
    if (this.itemSelecionado) {
      this.opcaoForm.reset({
        ordem: this.opcoes.length + 1,
        idTipoOpcao: '1'
      });
      
      this.carregarTriagens();
      
      this.modalService.open(this.modalNovaOpcao, {
        backdrop: 'static',
        keyboard: false
      });
    }
  }

  carregarTiposOpcao() {
    this.util.showLoading();
    this.ajax.get(`${API}TipoOpcao/TipoOpcao`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.tiposOpcao = response.data.map((tipo: any) => ({
              id: tipo.id,
              nome: tipo.nome
            }));
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar tipos de opção. Tente novamente.");
          console.error('Erro ao carregar tipos de opção:', error);
        }
      });
  }

  editarCronograma(cronograma: CronogramaBase) {
    this.cronogramaSelecionado = cronograma;
    this.cronogramaForm.patchValue({
      nome: cronograma.nome,
      dataCriacao: cronograma.dataCriacao
    });
    this.modalService.open(this.modalNovoCronograma, {
      backdrop: 'static',
      keyboard: false
    });
  }

  carregarTriagens() {
    this.util.showLoading();
    this.ajax.get(`${API}Triagem/Triagem`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.triagens = response.data.map((triagem: any) => ({
              id: triagem.id,
              titulo: triagem.titulo
            }));

            // Se houver uma opção selecionada com idTriagem, define o valor do select
            if (this.opcaoSelecionada && this.opcaoSelecionada.idTriagem) {
              setTimeout(() => {
                this.opcaoForm.patchValue({
                  idTriagem: this.opcaoSelecionada.idTriagem
                });
              });
            }
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar formulários. Tente novamente.");
          console.error('Erro ao carregar formulários:', error);
        }
      });
  }
} 